module.exports = __webpack_public_path__ + "static/img/remote_study_2.c5703256.jpg";